/**
 * @fileoverview Recognizes a My Page command refused because its version is stale.
 * @description My Page commands send the `tg1.` (target) or `od1.` (organisation details) version
 * the user reviewed as `If-Match`; the backend answers `412` when it has moved on since. Unlike the
 * prospect commands, a `409` here is a business rule (a stage move not allowed, a target already
 * closed, a reassignment pending, details not saved), whose own message the user must read, so only
 * `412` asks for a refresh-and-review.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { ApiException } from '@/shared/api/api.exception'

/**
 * @description Whether a My Page command failed because the record changed after it was read.
 * @param {unknown} error - The mutation's error.
 * @returns {boolean} True for a `412` response.
 */
export function isStaleMyPageError(error: unknown): boolean {
  return error instanceof ApiException && error.status === 412
}
